import React from 'react';

import LogoBg from '@assets/icons/fielder-logo-404.svg';
import LogoFielder from '@assets/icons/logo-login-main.svg';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
	Container, Logo, LogoBackground, Line, ErrorCode, ErrorText, StyledButtonWrapper
} from './Style';

const NotFound400 = ({ lan }) => {
	const navigate = useNavigate();
	const goBack = () => navigate(-1);
	return (
		<Grid container justifyContent="center" alignItems="stretch" spacing={3}>
			<Container container direction="column">
				<Grid><Logo src={LogoFielder} alt="Fielder Logo" /></Grid>
				<Grid><ErrorCode variant="h2">{lan.ERROR_404}</ErrorCode></Grid>
				<Grid><Line /></Grid>
				<Grid><ErrorText variant="h2">{lan.textNotFound404}</ErrorText></Grid>
				<StyledButtonWrapper item>
					<Button onClick={goBack} size="small" className="Fielder-button">{lan.return}</Button>
				</StyledButtonWrapper>
			</Container>
			<Grid container justifyContent="flex-start" alignItems="flex-end">
				<Grid><LogoBackground src={LogoBg} alt="Background" /></Grid>
			</Grid>
		</Grid>
	);
};

export default NotFound400;
